import styled, { keyframes } from "styled-components";
import React from "react";
// always use this component at the last of the jsx code
const slideIn = keyframes`
  from {
    transform: translateY(100%);
  }
  to {
    transform: translateY(0);
  }
`;

const slideOut = keyframes`
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(100%);
  }
`;

const Overlay = styled.div<{ isOpen: boolean }>`
  display: ${({ isOpen }) => (isOpen ? "block" : "none")};
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1000;
`;

const ModalContainer = styled.div<{
  isOpen: boolean;
  height: string;
  bgColor?: string;
}>`
  position: sticky;
  bottom: 0;
  left: 0;
  right: 0;
  background: ${({ bgColor }) => (bgColor ? bgColor : "white")};
  border-radius: 16px 16px 0 0;
  box-shadow: 0 -4px 10px rgba(0, 0, 0, 0.2);
  height: ${({ height }) => height};
  transition: transform 0.3s ease-in-out;
  transform: ${({ isOpen }) => (isOpen ? "translateY(0)" : "translateY(100%)")};
  animation: ${({ isOpen }) => (isOpen ? slideIn : slideOut)} 0.3s forwards;
  z-index: 1001;
`;

// HOC for the bottom modal
interface BottomModalProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
  bgColor?: string;
}
const BottomClipModal: React.FC<BottomModalProps> = ({
  isOpen,
  onClose,
  children,
  bgColor,
}) => {
  const contentHeight = React.Children.count(children) > 0 ? "auto" : "50px";

  return (
    <>
      {isOpen && (
        <>
          <Overlay isOpen={isOpen} onClick={onClose} />
          <ModalContainer
            bgColor={bgColor}
            isOpen={isOpen}
            height={contentHeight}
          >
            {children}
          </ModalContainer>
        </>
      )}
    </>
  );
};

export default BottomClipModal;
